import { create } from 'zustand';

const PROVIDER_METADATA_MAP = {
  autodesk: {
    displayName: 'name'
  },
  googledrive: {
    displayName: 'name'
  },
  redas: {
    displayName: 'name'
  }
};

const useConnectionStore = create((set) => ({
  activeConnectionId: '0',
  connectionOwnerName: '',
  provider: '',
  setActiveConnection: (data) => {
    const map = PROVIDER_METADATA_MAP[data.provider];

    set((state) => ({
      activeConnectionId: data.id,
      connectionOwnerName: data.provider == 'sgbuildex' ? data.metadata.data.identity.name : data.metadata[map.displayName],
      provider: data.provider
    }));
  },
  setInActiveConnection: () =>
    set((state) => ({
      activeConnectionId: '0',
      viewExtractType: ''
    }))
}));

export default useConnectionStore;
